'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var name = _ref.name,
        _ref$errors = _ref.errors,
        errors = _ref$errors === undefined ? [] : _ref$errors;
    return _react2.default.createElement(
        'div',
        { className: 'Errors ' + (errors.length ? 'show' : 'hide') },
        errors && errors.map(function (val) {
            return _react2.default.createElement(
                'div',
                { key: val },
                val
            );
        })
    );
};